var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryAmount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery_Amount",
    "data-name": "Delivery Amount",
    transform: "translate(5691 4665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6043",
    "data-name": "Group 6043",
    transform: "translate(-6732 -4969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6046",
    "data-name": "Group 6046",
    transform: "translate(148 194.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delivery_Truck",
    transform: "translate(-5806 -4824.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7169",
    "data-name": "Path 7169",
    d: "M29.559,99.017A9.559,9.559,0,0,1,20,89.458v-23.9A9.559,9.559,0,0,1,29.559,56H47.722a9.559,9.559,0,0,1,9.559,9.559V85.5",
    transform: "translate(-20 -56)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x1: 8.585,
    transform: "translate(19.316 43.224)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7170",
    "data-name": "Path 7170",
    d: "M332,176h9.559a9.559,9.559,0,0,1,9.559,9.559V199.9a4.78,4.78,0,0,1-4.78,4.78h-4.78",
    transform: "translate(-294.718 -161.661)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 4.65,
    cy: 4.65,
    r: 4.65,
    transform: "translate(37.201 38.216)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    cx: 5.008,
    cy: 4.65,
    rx: 5.008,
    ry: 4.65,
    transform: "translate(9.3 38.216)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7171",
    "data-name": "Path 7171",
    d: "M421.559,190.339h-4.78a4.78,4.78,0,0,1-4.78-4.78V176",
    transform: "translate(-365.159 -161.661)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6045",
    "data-name": "Group 6045",
    transform: "translate(-5791.862 -4814.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7172",
    "data-name": "Path 7172",
    d: "M156.7,228.669a3.519,3.519,0,1,0,2.815-5.631,3.519,3.519,0,1,1,2.815-5.631",
    transform: "translate(-156 -212.672)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    y1: 3.687,
    transform: "translate(3.397 17.381)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    y1: 3.16,
    transform: "translate(3.397 0)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryAmount);
export default __webpack_public_path__ + "static/media/DeliveryAmount.b8f84212652b638dc303074f068f364c.svg";
export { ForwardRef as ReactComponent };